// extracted by mini-css-extract-plugin
module.exports = {"header__icon":"header__icon-c4CcM","header__number":"header__number-3-oXB","option__included":"option__included-14Psf","option__money":"option__money-31mDl"};